import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "submit", "result", "resultStatus", "resultBody"];
  static values = {
    method: String,
    pathTemplate: String,
    proxyUrl: String
  };

  async run(event) {
    event.preventDefault();
    const originalText = this.submitTarget.textContent;
    this.submitTarget.disabled = true;
    this.submitTarget.textContent = "전송 중…";

    try {
      let path = this.pathTemplateValue.replace(/^https?:\/\/[^/]+/, "");
      const query = {};
      const body = {};

      this.inputTargets.forEach((input) => {
        const name = input.dataset.paramName;
        const where = input.dataset.paramIn;
        const type = input.dataset.paramType;
        const raw = input.value;

        if (raw === "" || raw == null) return;

        let value = raw;
        if (type === "boolean") value = raw === "true";
        else if (type === "integer") value = parseInt(raw, 10);

        if (where === "path") {
          path = path.replace(`:${name}`, encodeURIComponent(raw));
        } else if (where === "query") {
          query[name] = raw;
        } else {
          body[name] = value;
        }
      });

      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

      const response = await fetch(this.proxyUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken || ""
        },
        credentials: "same-origin",
        body: JSON.stringify({
          http_method: this.methodValue,
          path: path,
          query: query,
          body: body
        })
      });

      const payload = await response.json();

      if (!payload.ok) {
        this.showResult("ERROR", payload.error || "요청 실패", false);
        return;
      }

      let pretty;
      try {
        pretty = JSON.stringify(payload.body, null, 2);
      } catch (e) {
        pretty = String(payload.body);
      }

      this.showResult(payload.status, pretty, payload.status >= 200 && payload.status < 300);
    } catch (err) {
      this.showResult("ERROR", err.message, false);
    } finally {
      this.submitTarget.disabled = false;
      this.submitTarget.textContent = originalText;
    }
  }

  showResult(status, body, ok) {
    this.resultTarget.classList.remove("hidden");
    this.resultStatusTarget.textContent = String(status);
    const okClass =
      "inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-mono font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-800/60";
    const errClass =
      "inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-mono font-semibold bg-rose-50 text-rose-700 border border-rose-200 dark:bg-rose-900/20 dark:text-rose-300 dark:border-rose-800/60";
    this.resultStatusTarget.className = ok ? okClass : errClass;
    this.resultBodyTarget.textContent = body;
  }
}
